module.exports = __webpack_public_path__ + "img/egg_flames.f07073e0.svg";